export default "<style></style>\n\n<un--wrap data--unwrap--template>\n  <magic--wrap>@{}</magic--wrap>\n</un--wrap>";